import React, { useState } from 'react';
import './Navbar.css';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { Menu, MenuItem, Divider } from '@material-ui/core';
import navItems from '../_nav';
import NestedMenuItem from 'material-ui-nested-menu-item';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

function AppNavBar() {
  const [show, setShow] = useState(Array(navItems.items.length).fill(false));

  const showDropdown = (index) => {
    setShow((show) => {
      return show.map((item, showIndex) =>
        showIndex === index ? (item = true) : (item = false)
      );
    });
  };

  const hideDropdown = (index) => {
    setShow((show) => {
      return show.map((item, showIndex) =>
        showIndex === index ? (item = false) : item
      );
    });
  };

  const openSite = (e, url) => {
    if (typeof e.stopPropagation === 'function') {
      e.stopPropagation();
    }
    window.open(url, '_self');
  };

  return (
    <Navbar
      collapseOnSelect
      expand='lg'
      bg='#FFF'
      variant='light'
      className='padrl15'
    >
      <Navbar.Toggle aria-controls='responsive-navbar-nav' />
      <Navbar.Collapse id='responsive-navbar-nav'>
        <Nav className='mr-auto'>
          {navItems.items.map((item, index) => {
            return (
              <div key={index}>
                {item?.dropDownItems ? (
                  <NavDropdown
                    show={show[index]}
                    href={item.url}
                    onClick={(e) => openSite(e, item.url)}
                    onMouseEnter={() => showDropdown(index)}
                    onMouseLeave={() => hideDropdown(index)}
                    title={item.name}
                    id='collasible-nav-dropdown'
                  >
                    {item?.dropDownItems.map((dropDownItem, itemIndex) =>
                      dropDownItem.dropDownItems ? (
                        <NestedMenuItem
                          label={dropDownItem.name}
                          parentMenuOpen={true}
                          onClick={(e) => openSite(e, dropDownItem.url)}
                          rightIcon={
                            <ArrowForwardIcon style={{ color: 'grey' }} />
                          }
                        >
                          {dropDownItem?.dropDownItems.map(
                            (child, itemIndex) => (
                              <>
                                <MenuItem
                                  href={child.url}
                                  key={index + '' + itemIndex}
                                  onClick={(e) => openSite(e, child.url)}
                                  style={{
                                    color: '#b01e3f',
                                    background: '#fff',
                                    fontSize: '14px',
                                    fontFamily:
                                      '"Open Sans Condensed", sans-serif',
                                    fontWeight: 'bold',
                                    textTransform: 'uppercase',
                                    padding: '12px',
                                  }}
                                >
                                  {child.name}
                                </MenuItem>
                                {dropDownItem.dropDownItems.length - 1 !==
                                  itemIndex && (
                                  <Divider style={{ display: 'block' }} />
                                )}
                              </>
                            )
                          )}
                        </NestedMenuItem>
                      ) : (
                        <MenuItem
                          href={dropDownItem.url}
                          key={index + '' + itemIndex}
                          onClick={(e) => openSite(e, dropDownItem.url)}
                        >
                          {dropDownItem.name}
                        </MenuItem>
                      )
                    )}
                  </NavDropdown>
                ) : (
                  <Nav.Link href={item.url}>{item.name}</Nav.Link>
                )}
              </div>
            );
          })}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default AppNavBar;
